import { nav} from '@stores'
import {action, observable} from 'mobx'

export class CatalogNotesStore {
  @action addNote = ({id: productId, colorway: {comments: {id: commentsId}}}: any, navigateToNote = true) => {
    this.onClickAddNote(commentsId, productId)
    //navigateToNote && nav.updateQueryParams({noteContainer: commentsId})
  }

  @action onClickAddNote = (commentContainerId: string, productId?: string) => {
    //nav.updateQueryParams({catalogItem: productId ? productId : catalog.detailItemId, noteContainer: commentContainerId, noteAction: 'add'})
  }

  @observable comment: any = null
  @action update = (noteId: string, productId?: string) => {
    // nav.updateQueryParams({
    //                         noteContainer: undefined,
    //                         catalogItem: productId ? productId : catalog.detailItemId,
    //                         note: noteId,
    //                         notes: 'list',
    //                         noteAction: 'edit'
    //                       })

  }

  @action cancel = (showProductDetails?: boolean) => {
    // nav.updateQueryParams({
    //                         noteContainer: undefined,
    //                         note: undefined,
    //                         notes: showProductDetails ? undefined : nav.queryParams.notes,
    //                         noteAction: undefined
    //                       })
  }

  @action onClickNotes = (productId?: string) => {
    //nav.updateQueryParams({notes: 'list', catalogItem: productId ? productId : catalog.detailItemId})
  }

  @action onCloseNotes = () => {
    //nav.updateQueryParams({notes: undefined})
  }
}


/*
  @disposeOnUnmount refetchProductData = reaction(() => {
    const {product: {notesDelete, noteProductId}} = stores
    return {
      notesDelete,
      noteProductId
    }
  }, ({notesDelete, noteProductId}) => {
    if (notesDelete && noteProductId === this.props.data.id) {
      stores.product.notesDelete = false
      stores.product.noteProductId = null
      this.props.refetch && this.props.refetch()
    }
  })

  @action onClickNotes = (event) => {
    event.stopPropagation()
    stores.product.onClickNotes(this.props.data.id)
  }

 */


// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogNotesStore.ts